module.exports = __webpack_public_path__ + "img/ca.7cda37ce.svg";